<div [formGroup]="form">
  <input [attr.type]="field.type"
         class="form-control"
         [id]="field.name"
         [name]="field.name"
         [formControlName]="field.name" 
         [placeholder]="field.placeholder" />
</div>
